// @ts-ignore
import ReactDOMServer from "react-dom/server";
import React, { FC, ReactNode } from "react";
import LinearChart from "../../components/modules/dashboards/сharts/defaultCharts/linearChart/LinearChart";
import * as Highcharts from "highcharts";

// @ts-ignore
const move = ({ chart }) => (event) =>{
    // @ts-ignore
    var x = event.nativeEvent.chartX,
        y = event.nativeEvent.chartY,
        // @ts-ignore
        path = [
            // @ts-ignore
            'M', x, chart.plotTop,
            // @ts-ignore
            'L', x, chart.plotTop + chart.plotHeight],
        // @ts-ignore
        isOnPlot = function (x, y, chart) {
            return (
                x > chart.plotLeft &&
                x < chart.plotLeft + chart.plotWidth &&
                y > chart.plotTop &&
                y < chart.plotTop + chart.plotHeight
            )
        }

    // @ts-ignore
    if (chart.crossLines) {
        if (isOnPlot(x, y, chart)) {
            // update lines
            // @ts-ignore
            chart.crossLines.attr({
                d: path
            });
        } else {
            // @ts-ignore
            chart.crossLines.attr('d', '')
        }
    } else {
        // draw lines
        // @ts-ignore
        chart.crossLines = chart.renderer.path(path).attr({
            'stroke-width': 1,
            stroke: '#474A5A',
            zIndex: 10
        }).add();
    }
    // @ts-ignore
    if (chart.crossLabel) {
        if (isOnPlot(x, y, chart)) {
            // update label
            // @ts-ignore
            // @ts-ignore
            chart.crossLabel.attr({
                x: x - 15,
                text: ReactDOMServer.renderToString(
                    <div className='cross_label'>{
                        // @ts-ignore
                        new Date(Math.floor(chart?.yAxis[0].toValue(x).toFixed(2))).getDate()
                    }</div>
                )
            });
        } else {
            // @ts-ignore
            chart.crossLabel.attr('x', -9999)
        }
    } else {
        // draw label
        // @ts-ignore
        chart.crossLabel = chart.renderer.text(chart.xAxis[0].toValue(x).toFixed(2), x - 15, chart.chartHeight - 12, true).add();
    }
}
export const HCColumnRangeLine: FC<{ children: ReactNode, chart?: Highcharts.Chart}> = (props: any) => {
    return <div onMouseMove={move(props)}>{props.children}</div>
}